import { AreaChart } from '@mantine/charts';
import { Skeleton } from '@mantine/core';
import { formatToCurrency, formatToDateString } from '../../../util/formatting';
import type { EodLogChartLineDto } from '../types/EodLogDto';

interface EodAreaLogsChartProps {
	lines?: EodLogChartLineDto[];
	isLoading: boolean;
}

export function EodAreaLogsChart({ lines, isLoading }: EodAreaLogsChartProps) {
	return (
		<>
			<Skeleton visible={isLoading} h={'100%'}>
				<AreaChart
					h={'16vh'}
					data={mapToChartData(lines)}
					dataKey={'date'}
					valueFormatter={(value) => formatToCurrency(value)}
					series={mapToSeriesData(lines)}
					curveType={'linear'}
				/>
			</Skeleton>
		</>
	);
}

export function mapToChartData(
	eodLines?: EodLogChartLineDto[],
): Record<string, any>[] {
	if (eodLines == null) {
		return noDataToDisplay;
	}

	return eodLines.map((eodLine) => {
		const branches = eodLine.chartPoints.reduce(
			(acc, point) => {
				acc[`${point.branchName}`] = point.netSales;
				return acc;
			},
			{} as Record<string, number>,
		);

		return {
			date: formatToDateString(eodLine.dateTime),
			...branches,
		};
	});
}

export function mapToSeriesData(
	eodLines?: EodLogChartLineDto[],
): { label: string; name: string; color: string }[] {
	if (eodLines == null) {
		return [];
	}

	const uniqueBranches = new Set<string>();

	// biome-ignore lint/complexity/noForEach: <explanation>
	eodLines.forEach((eodLine) => {
		// biome-ignore lint/complexity/noForEach: <explanation>
		eodLine.chartPoints.forEach((point) => {
			uniqueBranches.add(point.branchName);
		});
	});

	return Array.from(uniqueBranches).map((branchName, index) => ({
		label: branchName,
		name: branchName,
		color: 'medepos-secondary.1',
	}));
}

const noDataToDisplay = [
	{
		date: 'No Data',
		netAmount: 0,
	},
];
